// MUI
import { Box, Skeleton, SvgIcon } from "@mui/material";
// Components
import DoubleCheckingButton from "../../Buttons/DoubleCheckingButton";
// Icons
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { ReactComponent as TrashIcon } from "@/assets/icons/actions/trash.svg";

interface IDeletableProps {
	deletable?: boolean;
	loading?: boolean;
	deleteTitle?: string;
	icon?: React.ReactNode;
	iconHover?: React.ReactNode;
	onDeleteAction?: () => void;
	readOnly?: boolean;
}

const Deletable = (props: IDeletableProps) => {
	const { deletable, loading, deleteTitle, icon, iconHover, onDeleteAction, readOnly } = props;
	if (!deletable) {
		return null;
	}

	return (
		<Box sx={{ position: "absolute", right: "0" }}>
			{loading ? (
				<Skeleton variant="circular" width={35} height={35} />
			) : (
				<DoubleCheckingButton
					title={deleteTitle ?? "Remove Queue"}
					icon={icon || <CloseRoundedIcon />}
					iconHover={iconHover || <CloseRoundedIcon />}
					endIcon={<SvgIcon className="!text-[16px] ml-[4px]" component={TrashIcon} viewBox="0 0 14 14" />}
					mainButtonClasses={"btn-simple-remove"}
					confirmationSx={{ right: "0px !important", width: "140px !important" }}
					onDeleteAction={onDeleteAction}
					disabled={readOnly}
				/>
			)}
		</Box>
	);
};

export default Deletable;
